import firebase from 'firebase'
var config = {
  apiKey: "AIzaSyDb_qRRRgFq0qCWsEiwvjTFILR_yOuZeHM",
  authDomain: "gyftspace.firebaseapp.com",
  databaseURL: "https://gyftspace.firebaseio.com",
  projectId: "gyftspace",
  storageBucket: "gyftspace.appspot.com",
  messagingSenderId: "418895351093"
};
firebase.initializeApp(config);

export const provider = new firebase.auth.GoogleAuthProvider();
export const auth = firebase.auth();
export default firebase;



// WEBPACK FOOTER //
// ./src/firebase.js